import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Label } from "../ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../ui/select";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";
import { Coins, Loader2, Users, Trash2, Plus, ArrowRight, X, Clock, MapPin, Crosshair, Send, Check, AlertCircle, DollarSign } from "lucide-react";

export default function ApplyClientModal({
  showApplyAsClient, setShowApplyAsClient, applyForm, setApplyForm,
  handleApplyAsClient, actionLoading, userCharacters, formatMesos, clientApplyIgn, setClientApplyIgn
}) {
  return (
      <Dialog open={!!showApplyAsClient} onOpenChange={() => { setShowApplyAsClient(null); setClientApplyIgn(""); }}>
        <DialogContent className="max-w-md" style={{ background: "linear-gradient(180deg, #451a03 0%, #1c0a00 100%)", border: "2px solid #d97706" }}>
          <DialogHeader>
            <DialogTitle className="text-amber-300 flex items-center gap-2">
              <DollarSign className="w-5 h-5" /> Join as Buyer
            </DialogTitle>
            <DialogDescription className="text-amber-200/60">
              Apply to buy a run for {showApplyAsClient?.boss_name}
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            <div className="p-3 rounded-lg bg-black/30 border border-amber-500/20">
              <p className="text-sm text-amber-300/70">Price: <span className="text-amber-400 font-bold">{formatMesos(showApplyAsClient?.price_for_client) || "TBD"}</span></p>
              <p className="text-sm text-amber-300/70">Leader: <span className="text-white">{showApplyAsClient?.leader_username}</span></p>
            </div>
            <div>
              <Label className="text-amber-200">Your Contact IGN *</Label>
              <Input
                placeholder="Your in-game name"
                value={clientApplyIgn}
                onChange={(e) => setClientApplyIgn(e.target.value)}
                className="bg-black/40 border-amber-500/40 text-white"
                data-testid="client-apply-ign"
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="ghost" onClick={() => { setShowApplyAsClient(null); setClientApplyIgn(""); }}>Cancel</Button>
            <Button
              className="font-bold"
              style={{ background: "linear-gradient(180deg, #d97706 0%, #b45309 100%)", border: "2px solid #f59e0b" }}
              onClick={() => handleApplyAsClient(showApplyAsClient?.id)}
              disabled={!clientApplyIgn.trim()}
              data-testid="client-apply-submit"
            >
              <DollarSign className="w-4 h-4 mr-2" /> Apply as Buyer
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
  );
}
